import React from 'react';
import { ServiceAreasSection } from '../components/sections/ServiceAreasSection';
import { ServiceAreaMapSection } from '../components/sections/ServiceAreaMapSection';
import { CTABanner } from '../components/sections/CTABanner';
export function ServiceAreasPage() {
  return <>
      {/* Page Header */}
      <section className="bg-[#0B1F3A] text-white py-20" data-id="element-408">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-409">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-410">Service Areas</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-411">
            We proudly serve Upper Marlboro, MD and surrounding communities
          </p>
        </div>
      </section>

      <ServiceAreasSection data-id="element-412" />
      <ServiceAreaMapSection data-id="element-413" />
      <CTABanner data-id="element-414" />
    </>;
}